import {formatDateToLocal, onlyTime, optional} from "../../../../../Helpers/Helpers";
export const TableHelpers = {
    data() {
        return {
            tableColumns : [
                {
                    title: this.$t('title'),
                    type: 'text',
                    key: 'title',
            
                },
                {
                    title: this.$t('category'),
                    type: 'text',
                    key: 'category',
            
                },
                {
                    title: this.$t('date'),
                    type: 'object',
                    key: 'created_at',
                    uniqueKey: 'id',
                    modifier: function (created_at, rowData) {
                                return formatDateToLocal(created_at)
                    }
            
                },
                {
                    title: this.$t('status'),
                    type: 'custom-html',
                    key: 'status',
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'danger';

                            if (value === 'active') ClassName = `success`;
                            else if (value === 'inactive') ClassName = `warning`;

                            return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(value)}</span>`;
                        }
                    }
                },
            ],
            actionObj : {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}